import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  private orgApiUrl = environment.apibaseUrl + '/organization';
  private baseUrl = environment.apibaseUrl;

  constructor(private http: HttpClient) { }

  public getReferralList(type,formName:string=null) {
    return this.http.get(this.baseUrl + '/referral/list?type=' + type +'&formName=' + formName);
  }

  public getReferralTypes() {
    return this.http.get(this.baseUrl + '/referral/types/list');
  }

  public getStudentgradelist(issueCategoryName=null) {
    return this.http.get(this.baseUrl + '/referral/studentGrade/list?issueCategoryName='+issueCategoryName);
  }

  getClinicList() {
    return this.http.get(this.orgApiUrl + '/clinic');
  }

  getpatientListByClinicId(clinicId) {
    return this.http.get(this.baseUrl + '/referral/patient/list/' + clinicId);
  }

  saveReferral(referralDetails) {
    return this.http.post(this.baseUrl + '/referral/save', referralDetails);
  }
  

  referralInfo(referralId) {
    return this.http.get(this.baseUrl + '/referral/info/' + referralId);
  }

  public saveAssignedData(data) {
    return this.http.post(this.baseUrl + '/referral/', data);
  }

  public deleteReferralForm(id: number) {
    return this.http.delete(this.baseUrl + '/referral?referralId=' + id);
  }

  public getClinicianReferralList() {
    return this.http.get(this.baseUrl + '/referral/clinicianReferalList');
  }
  getReferralOuestions(referralId,formName) {
    return this.http.get(this.baseUrl + '/referral/view/' + referralId+"/"+formName);
  }

}
